import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DataRetentionSettingsState = {
  dataRetentionSettings: {},
  dataRetentionSettingsLoading: false,
}

export const DataRetentionSettingsActions = {
  createDataRetentionSettings: async ({ commit }, value) => {
    commit('setDataRetentionSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'data_retention',
        value,
      }).
      then(({ data }) => {
        commit('setDataRetentionSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDataRetentionSettingsLoading', false))
  },

  getDataRetentionSettings: async ({ commit }) => {
    commit('setDataRetentionSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/data_retention').
      then(({ data }) => {
        commit('setDataRetentionSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDataRetentionSettingsLoading', false))
  },

  updateDataRetentionSettings: async ({ getters, commit }, value) => {
    commit('setDataRetentionSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.dataRetentionSettingsId}`, {
        name: 'data_retention',
        value,
      }).
      then(({ data }) => {
        commit('setDataRetentionSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDataRetentionSettingsLoading', false))
  },

  deleteDataRetentionSettings: async ({ getters, commit }) => {
    commit('setDataRetentionSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.dataRetentionSettingsId}`).
      then(({ data }) => {
        commit('setDataRetentionSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDataRetentionSettingsLoading', false))
  },
}

export const DataRetentionSettingsMutations = {
  setDataRetentionSettings: (state, value) => { state.dataRetentionSettings = value },
  setDataRetentionSettingsLoading: (state, value) => { state.dataRetentionSettingsLoading = value },
}

export const DataRetentionSettingsGetters = {
  dataRetentionSettings: state => state.dataRetentionSettings,
  dataRetentionSettingsId: state => state.dataRetentionSettings?.id,
  dataRetentionSettingsLoading: state => state.dataRetentionSettingsLoading,
  dataRetentionSettingsValue: state => state.dataRetentionSettings?.value,
}
